import { Component } from 'react';
import { RefreshCw, Home } from 'lucide-react';
import { tr } from '@/contexts/LanguageContext';
import { reportClientError, recoverFromChunkError } from '@/lib/clientErrors';

/** Pantalla global amigable (oct-2026): cualquier error de render muestra esto en vez de una pantalla en blanco. */
export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[app-error]', error, info?.componentStack);
    if (recoverFromChunkError(error)) return;
    reportClientError(error, { kind: 'render', componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="app-error-screen">
        <div className="max-w-sm w-full text-center space-y-4">
          <p className="text-[10px] uppercase tracking-[0.25em] text-primary font-bold">Ziyup</p>
          <h1 className="font-display text-2xl font-bold text-foreground">{tr("Algo salió mal")}</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">{tr("No fue tu culpa. Tus citas y tus pagos están a salvo. Recarga la pantalla para continuar; si vuelve a pasar, escríbenos desde el formulario de contacto.")}</p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-5 py-3 text-sm hover:opacity-90 transition-opacity"
              data-testid="app-error-reload-btn"
            >
              <RefreshCw className="w-4 h-4" />{' '}{tr("Recargar la pantalla")}</button>
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-border text-foreground font-semibold px-5 py-3 text-sm hover:bg-secondary transition-colors"
              data-testid="app-error-home-link"
            >
              <Home className="w-4 h-4" />{' '}{tr("Ir al inicio")}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
